// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #fff;
  --primary: #5541d7;
  --primary-70: #2a23c2;
  --primary-30: #766eda;
  --primary-10: #dbd7f4;
  --button-hover: #4434af;
  --basic-button-hover: #eeeff7;
  --grey: #7f7f7f;
  --grey-text: #9a9ab0;
  --grey-text-second: #92929d;
  --grey-icon: #4c4c4c;
  --grey-border: #e1e1e1;
  --grey-secondary: #DBE2F9;
  --light-grey: #e0e0e0;
  --red: #ba3a3a;
  --red-bg: #fdebeb;
  --red-hover: #d14b4b;
  --red-active: #8c2a2a;
  --red-disable: #afafaf;
  --red-light: #fdebeb;
  --black: #120f39;
  --bg: #f7f7fc;
  --chart-purple: #512ca0;
  --chart-grey: #e2e2ea;
  --pist: #E3EFE8;
  --green: #378b59;
  --green-button: #31c67e;
  --green-button-hover: #2aa96c;
  --green-button-active: #ade8cb;
  --grey-variable: #e0e0e059;
  --grey-variable-hover: #e2e2ea;
  --orange: #d9790c;
  --orange-secondary: #f9d48d;
  --orange-light-secondary: #fef7e8;
  --orange-light: #fff4dc;
  --icon-primary-color: var(--grey-icon);
  --fill-progress-color: #cae4db;
  --bg-progress-color: var(--chart-grey);
  --unfill-progress-color: var(--bg-progress-color);
  --span-text-color: var(--primary);
  --box-shadow: 0 2px 3px rgba(227, 225, 240, 0.5);
  --card-border-color: var(--grey-border);
  --header-border-color: #e1e3eb;
  --element-shadow: 0 1.6rem 1.6rem rgba(97, 97, 97, 0.1), 0 0.8rem 1.6rem rgba(97, 97, 97, 0.1);
  --chart-progress-secondary: var(--grey-secondary);
  --chart-som: #181485;
  --chart-sam: #5541D7;
  --chart-tam: #9A9AB0;
  --chart-pam: #F7F7FC;
  --radio-border: var(--grey-border);
  --radio-main: var(--white);
  --chips-bg: var(--grey-variable);
  --chips-bg-hover: var(--grey-variable-hover);
  --chips-border-hover: inherit;
  --chips-text-hover: inherit;
  --element-hover: var(--bg);
  --element-row-border: var(--grey-secondary);
  --comment-block: #f4f4f4;
  --table-header: #ededfd;
  --side-menu-border: var(--grey-border);
  --side-menu-shadow: 0px 6px 20px rgba(24, 20, 51, 0.1), -8px 0px 16px rgba(97, 97, 97, 0.1);
  --side-menu-divider: var(--grey-border);
  --font-family: "Roboto", sans-serif;
  --font-family-second: "Mulish", sans-serif;
  --primary-20: #22293A;
  --primary-60: #141B25;
  --text-40: #8990A5;
  --text-70: #BFC6DC;
  --txt-100: #120F39;
  --shadow-30: #1F2431;
  --section-bg-helper: #e1e1fb;
}

@font-face {
  font-family: "icomoon";
  src: url('icomoon.f02afaaa329d5c83.eot?szk3ld');
  src: url('icomoon.f02afaaa329d5c83.eot?szk3ld#iefix') format("embedded-opentype"), url('icomoon.c9178e95b91cf012.ttf?szk3ld') format("truetype"), url('icomoon.27c3977b1384defc.woff?szk3ld') format("woff"), url('icomoon.d01e00d3204e7d77.svg?szk3ld#icomoon') format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-logout:before {
  content: "\\e923";
  color: #4c4c4c;
}

.icon-lock:before {
  content: "\\e924";
  color: #4c4c4c;
}

.icon-tariff:before {
  content: "\\e925";
  color: #4c4c4c;
}

.icon-telegram:before {
  content: "\\e922";
  color: var(--primary);
}

.icon-file-email:before {
  content: "\\e91f";
  color: #4c4c4c;
}

.icon-file-xml:before {
  content: "\\e920";
  color: #1c4b76;
}

.icon-help:before {
  content: "\\e921";
  color: #4c4c4c;
}

.icon-upload:before {
  content: "\\e91d";
  color: var(--icon-primary-color);
}

.icon-complete:before {
  content: "\\e91e";
  color: #4c4c4c;
}

.icon-checkbox-selected:before {
  content: "\\e919";
  color: var(--primary);
}

.icon-checkbox:before {
  content: "\\e91a";
  color: #4c4c4c;
}

.icon-radio-selected:before {
  content: "\\e91b";
  color: var(--primary);
}

.icon-radio:before {
  content: "\\e91c";
  color: #e1e1e1;
}

.icon-add-new-outline:before {
  content: "\\e902";
  /* color: #4c4c4c; */
}

.icon-file-excel:before {
  content: "\\e903";
  color: #378b59;
}

.icon-account:before {
  content: "\\e900";
  color: #4c4c4c;
}

.icon-add-new:before {
  content: "\\e901";
}

.icon-arrow:before {
  content: "\\e904";
}

.icon-calendar:before {
  content: "\\e905";
  color: #4c4c4c;
}

.icon-cancel:before {
  content: "\\e906";
  /* color: #4c4c4c; */
}

.icon-charts:before {
  content: "\\e907";
  /* color: #4c4c4c; */
}

.icon-comment:before {
  content: "\\e908";
  /* color: #4c4c4c; */
}

.icon-copy:before {
  content: "\\e909";
  /* color: #4c4c4c; */
}

.icon-copyright:before {
  content: "\\e90a";
  color: #92929d;
}

.icon-delete:before {
  content: "\\e90b";
  /* color: #4c4c4c; */
}

.icon-download:before {
  content: "\\e90c";
  color: #4c4c4c;
}

.icon-edit:before {
  content: "\\e90d";
  /* color: #4c4c4c; */
}

.icon-export:before {
  content: "\\e90e";
  color: #4c4c4c;
}

.icon-eye:before {
  content: "\\e90f";
  color: #9a9ab0;
}

.icon-eye-hide:before {
  content: "\\e910";
  color: #9a9ab0;
}

.icon-file-image:before {
  content: "\\e911";
  color: #d9790c;
}

.icon-file-pdf:before {
  content: "\\e912";
  color: #ba3a3a;
}

.icon-file-text:before {
  content: "\\e913";
  color: #6badea;
}

.icon-folder:before {
  content: "\\e914";
  /* color: #4c4c4c; */
}

.icon-mark:before {
  content: "\\e915";
  color: #4c4c4c;
}

.icon-notes:before {
  content: "\\e916";
  color: #4c4c4c;
}

.icon-reports:before {
  content: "\\e917";
  /* color: #4c4c4c; */
}

.icon-search:before {
  content: "\\e918";
  /* color: #4c4c4c; */
}

.icon-bar-chart:before {
  content: "\\e92c";
}

.icon-bar-chart-2:before {
  content: "\\e92d";
}

.icon-icon-gears:before {
  content: "\\e927";
  color: #312782;
}

.icon-book .path1:before {
  content: "\\e930";
  color: rgb(255, 255, 255);
}

.icon-book .path2:before {
  content: "\\e931";
  margin-left: -1em;
  color: rgb(76, 76, 76);
}

.icon-book .path3:before {
  content: "\\e932";
  margin-left: -1em;
  color: rgb(76, 76, 76);
}

.icon-lamp:before {
  content: "\\e933";
  color: #5541d7;
}

.icon-feature-locked .path1:before {
  content: "\\e92a";
  color: rgb(49, 198, 126);
}

.icon-feature-locked .path2:before {
  content: "\\e92b";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.icon-feature-img-locked .path1:before {
  content: "\\e92e";
  color: rgb(49, 198, 126);
  opacity: 0.4;
}

.icon-feature-img-locked .path2:before {
  content: "\\e92f";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.icon-icon-arrow-down:before {
  content: "\\e928";
  /* color: #4c4c4c; */
}

.icon-icon-arrow-up:before {
  content: "\\e929";
  /* color: #4c4c4c; */
}

.icon-ic-alert:before {
  content: "\\e926";
}

:host {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}

.lock {
  font-size: 18px;
  position: absolute;
  top: 0px;
  right: 5px;
}

.lock-full-stroke {
  font-size: 18px;
  position: absolute;
  right: -16px;
}

.lock-stroke {
  font-size: 18px;
  position: absolute;
  top: 3px;
  right: -16px;
}

.lock-scenario {
  font-size: 18px;
  position: absolute;
  top: 3px;
  right: 149px;
  z-index: 20;
}

.lock-input {
  font-size: 18px;
  position: absolute;
  top: 3px;
  right: 0px;
}

.lock-input-label {
  font-size: 18px;
  position: absolute;
  top: -10.5px;
  right: 0px;
}

.lock-title {
  font-size: 18px;
  position: relative;
  top: 0px;
  right: 0px;
  width: 18px;
}

.icon-feature-locked .path1:before {
  content: "\\e92a";
  color: rgb(49, 198, 126);
}

.icon-feature-locked .path2:before {
  content: "\\e92b";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.container {
  pointer-events: none;
  padding-right: 13px;
}

.disabled-container {
  opacity: 0.4;
}

.wrap-mount {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: calc(100% + 30px);
}

.wrap {
  width: 283px;
  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.18));
  position: absolute;
  z-index: 16;
}
.wrap .popover-triangle {
  content: "";
  width: 2rem;
  height: 2rem;
  background: var(--white);
  position: absolute;
  top: calc(50% - 1rem);
  left: 0;
  transform: rotate(45deg) translateX(-20%);
}
.wrap .popover {
  font-size: 1.4rem;
  line-height: 1.8rem;
  background: var(--white);
  padding: 20px;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.wrap .popover .popover-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.wrap .popover .popover-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
}
.wrap .popover .popover-description .text-primary {
  color: var(--primary);
}
.wrap .popover button {
  width: 160px;
  margin-top: 10px;
}

.wrap-btn {
  top: -200%;
  left: calc(100% - 25px);
}

.wrap-variant-btn {
  top: -230%;
  left: calc(100% - 25px);
}

.wrap-stroke {
  top: -230%;
  left: calc(100% - 2px);
}

.wrap-checkbox {
  top: -300%;
}

.wrap-input {
  top: -62px;
  left: 27px;
}

.wrap-input2 {
  top: -65px;
  left: 40px;
}

.icon-file-excel:before {
  content: "\\e903";
  color: #378b59;
  cursor: pointer;
  font-size: 2.4rem;
}
.icon-file-excel:before:hover {
  border-color: var(--primary-30);
}
.icon-file-excel:before:active {
  border-color: var(--primary);
}
.icon-file-excel:before:disabled {
  border: 0.1rem solid var(--grey-variable-hover);
  opacity: 0.5;
  cursor: default;
}

.wraper-button {
  position: relative;
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
}

.icon-add-new {
  font-size: 22px;
}
.icon-add-new:before {
  content: "\\e901";
  color: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/shared/locker/locker/locker.component.scss","webpack://./src/styles/icomoon.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;EACA,2BAAA;EACA,iCAAA;EACA,uBAAA;EAEA,sCAAA;EACA,8BAAA;EACA,sCAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,uCAAA;EACA,8BAAA;EACA,8FAAA;EACA,iDAAA;EAEA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,kCAAA;EACA,0BAAA;EAEA,gCAAA;EACA,4CAAA;EACA,6BAAA;EACA,2BAAA;EAEA,0BAAA;EACA,2CAAA;EAEA,wBAAA;EAEA,uBAAA;EAEA,sCAAA;EACA,2FAAA;EACA,uCAAA;EAEA,mCAAA;EACA,0CAAA;EAEA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;ACTF;;ACxEA;EACE,sBAAA;EACA,+CAAA;EACA,8QACE;EAIF,mBAAA;EACA,kBAAA;EACA,mBAAA;ADuEF;ACxDA;;EAEE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;ADyDF;;ACtDA;EACE,gBAAA;EACA,cAAA;ADyDF;;ACvDA;EACE,gBAAA;EACA,cAAA;AD0DF;;ACxDA;EACE,gBAAA;EACA,cAAA;AD2DF;;ACzDA;EACE,gBAAA;EACA,qBAAA;AD4DF;;AC1DA;EACE,gBAAA;EACA,cAAA;AD6DF;;AC3DA;EACE,gBAAA;EACA,cAAA;AD8DF;;AC5DA;EACE,gBAAA;EACA,cAAA;AD+DF;;AC7DA;EACE,gBAAA;EAEA,gCAAA;AD+DF;;AC7DA;EACE,gBAAA;EACA,cAAA;ADgEF;;AC9DA;EACE,gBAAA;EACA,qBAAA;ADiEF;;AC/DA;EACE,gBAAA;EACA,cAAA;ADkEF;;AChEA;EACE,gBAAA;EACA,qBAAA;ADmEF;;ACjEA;EACE,gBAAA;EACA,cAAA;ADoEF;;AClEA;EACE,gBAAA;EACA,oBAAA;ADqEF;;ACnEA;EACE,gBAAA;EACA,cAAA;ADsEF;;ACpEA;EACE,gBAAA;EACA,cAAA;ADuEF;;ACrEA;EACE,gBAAA;ADwEF;;ACrEA;EACE,gBAAA;ADwEF;;ACtEA;EACE,gBAAA;EACA,cAAA;ADyEF;;ACvEA;EACE,gBAAA;EACA,oBAAA;AD0EF;;ACxEA;EACE,gBAAA;EACA,oBAAA;AD2EF;;ACzEA;EACE,gBAAA;EACA,oBAAA;AD4EF;;AC1EA;EACE,gBAAA;EACA,oBAAA;AD6EF;;AC3EA;EACE,gBAAA;EACA,cAAA;AD8EF;;AC5EA;EACE,gBAAA;EACA,oBAAA;AD+EF;;AC7EA;EACE,gBAAA;EACA,cAAA;ADgFF;;AC9EA;EACE,gBAAA;EACA,oBAAA;ADiFF;;AC/EA;EACE,gBAAA;EACA,cAAA;ADkFF;;AChFA;EACE,gBAAA;EACA,cAAA;ADmFF;;ACjFA;EACE,gBAAA;EACA,cAAA;ADoFF;;AClFA;EACE,gBAAA;EACA,cAAA;ADqFF;;ACnFA;EACE,gBAAA;EACA,cAAA;ADsFF;;ACpFA;EACE,gBAAA;EACA,cAAA;ADuFF;;ACrFA;EACE,gBAAA;EACA,oBAAA;ADwFF;;ACtFA;EACE,gBAAA;EACA,cAAA;ADyFF;;ACvFA;EACE,gBAAA;EACA,cAAA;AD0FF;;ACxFA;EACE,gBAAA;EACA,oBAAA;AD2FF;;ACzFA;EACE,gBAAA;EACA,oBAAA;AD4FF;;AC1FA;EACE,gBAAA;AD6FF;;AC3FA;EACE,gBAAA;AD8FF;;AC5FA;EACE,gBAAA;EACA,cAAA;AD+FF;;AC7FA;EACE,gBAAA;EACA,yBAAA;ADgGF;;AC9FA;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;ADiGF;;AC/FA;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;ADkGF;;AChGA;EACE,gBAAA;EACA,cAAA;ADmGF;;ACjGA;EACE,gBAAA;EACA,wBAAA;ADoGF;;AClGA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;ADqGF;;ACnGA;EACE,gBAAA;EACA,wBAAA;EACA,YAAA;ADsGF;;ACpGA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;ADuGF;;ACrGA;EACE,gBAAA;EACA,oBAAA;ADwGF;;ACtGA;EACE,gBAAA;EACA,oBAAA;ADyGF;;ACvGA;EACE,gBAAA;AD0GF;;AAhWA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAmWF;;AAhWA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAmWF;;AAhWA;EACE,gBAAA;EACA,wBAAA;AAmWF;;AAhWA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;AAmWF;;AAhWA;EACE,oBAAA;EACA,mBAAA;AAmWF;;AAhWA;EACE,YAAA;AAmWF;;AAhWA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,wBAAA;AAmWF;;AAhWA;EACE,YAAA;EACA,wDAAA;EACA,kBAAA;EACA,WAAA;AAmWF;AAjWE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,yCAAA;AAmWJ;AAhWE;EACE,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAkWJ;AAhWI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAkWN;AA/VI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAiWN;AA/VM;EACE,qBAAA;AAiWR;AA7VI;EACE,YAAA;EACA,gBAAA;AA+VN;;AA1VA;EACE,UAAA;EACA,uBAAA;AA6VF;;AA1VA;EACE,UAAA;EACA,uBAAA;AA6VF;;AA1VA;EACE,UAAA;EACA,sBAAA;AA6VF;;AA1VA;EACE,UAAA;AA6VF;;AA1VA;EACE,UAAA;EACA,UAAA;AA6VF;;AA1VA;EACE,UAAA;EACA,UAAA;AA6VF;;AA1VA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA6VF;AA3VE;EACE,+BAAA;AA6VJ;AA1VE;EACE,4BAAA;AA4VJ;AAzVE;EACE,+CAAA;EACA,YAAA;EACA,eAAA;AA2VJ;;AAvVA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA0VF;;AAtVA;EACE,eAAA;AAyVF;AAvVE;EACE,gBAAA;EACA,qBAAA;AAyVJ","sourcesContent":[":root {\n  --white: #fff;\n  --primary: #5541d7;\n  --primary-70: #2a23c2;\n  --primary-30: #766eda;\n  --primary-10: #dbd7f4;\n  --button-hover: #4434af;\n  --basic-button-hover: #eeeff7;\n  --grey: #7f7f7f;\n  --grey-text: #9a9ab0;\n  --grey-text-second: #92929d;\n  --grey-icon: #4c4c4c;\n  --grey-border: #e1e1e1;\n  --grey-secondary: #DBE2F9;\n  --light-grey: #e0e0e0;\n  --red: #ba3a3a;\n  --red-bg: #fdebeb;\n  --red-hover: #d14b4b;\n  --red-active: #8c2a2a;\n  --red-disable: #afafaf;\n  --red-light: #fdebeb;\n  --black: #120f39;\n  --bg: #f7f7fc;\n  --chart-purple: #512ca0;\n  --chart-grey: #e2e2ea;\n  --pist: #E3EFE8;\n  --green: #378b59;\n  --green-button: #31c67e;\n  --green-button-hover: #2aa96c;\n  --green-button-active: #ade8cb;\n  --grey-variable: #e0e0e059;\n  --grey-variable-hover: #e2e2ea;\n  --orange: #d9790c;\n  --orange-secondary: #f9d48d;\n  --orange-light-secondary: #fef7e8;\n  --orange-light: #fff4dc;\n\n  --icon-primary-color: var(--grey-icon);\n  --fill-progress-color: #cae4db;\n  --bg-progress-color: var(--chart-grey);\n  --unfill-progress-color: var(--bg-progress-color);\n  --span-text-color: var(--primary);\n  --box-shadow: 0 2px 3px rgba(227, 225, 240, 0.5);\n  --card-border-color: var(--grey-border);\n  --header-border-color: #e1e3eb;\n  --element-shadow: 0 1.6rem 1.6rem rgba(97, 97, 97, 0.1), 0 0.8rem 1.6rem rgba(97, 97, 97, 0.1);\n  --chart-progress-secondary: var(--grey-secondary);\n\n  --chart-som: #181485;\n  --chart-sam: #5541D7;\n  --chart-tam: #9A9AB0;\n  --chart-pam: #F7F7FC;\n\n  --radio-border: var(--grey-border);\n  --radio-main: var(--white);\n\n  --chips-bg: var(--grey-variable);\n  --chips-bg-hover: var(--grey-variable-hover);\n  --chips-border-hover: inherit;\n  --chips-text-hover: inherit;\n\n  --element-hover: var(--bg);\n  --element-row-border: var(--grey-secondary);\n\n  --comment-block: #f4f4f4;\n\n  --table-header: #ededfd;\n\n  --side-menu-border: var(--grey-border);\n  --side-menu-shadow: 0px 6px 20px rgba(24, 20, 51, 0.1), -8px 0px 16px rgba(97, 97, 97, 0.1);\n  --side-menu-divider: var(--grey-border);\n\n  --font-family: 'Roboto', sans-serif;\n  --font-family-second: 'Mulish', sans-serif;\n\n  --primary-20: #22293A;\n  --primary-60: #141B25;\n  --text-40: #8990A5;\n  --text-70: #BFC6DC;\n  --txt-100: #120F39;\n  --shadow-30: #1F2431;\n  --section-bg-helper: #e1e1fb;\n}","@import 'src/styles/variables.scss';\n@import 'src/styles/icomoon';\n\n:host {\n  position: relative;\n  user-select: none;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.lock {\n  font-size: 18px;\n  position: absolute;\n  top: 0px;\n  right: 5px;\n}\n\n.lock-full-stroke {\n  font-size: 18px;\n  position: absolute;\n  right: -16px;\n}\n\n.lock-stroke {\n  font-size: 18px;\n  position: absolute;\n  top: 3px;\n  right: -16px;\n}\n\n.lock-scenario {\n  font-size: 18px;\n  position: absolute;\n  top: 3px;\n  right: 149px;\n  z-index: 20;\n}\n\n.lock-input {\n  font-size: 18px;\n  position: absolute;\n  top: 3px;\n  right: 0px;\n}\n\n.lock-input-label {\n  font-size: 18px;\n  position: absolute;\n  top: -10.5px;\n  right: 0px;\n}\n\n.lock-title {\n  font-size: 18px;\n  position: relative;\n  top: 0px;\n  right: 0px;\n  width: 18px;\n}\n\n.icon-feature-locked .path1:before {\n  content: '\\e92a';\n  color: rgb(49, 198, 126);\n}\n\n.icon-feature-locked .path2:before {\n  content: '\\e92b';\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.container {\n  pointer-events: none;\n  padding-right: 13px;\n}\n\n.disabled-container {\n  opacity: 0.4;\n}\n\n.wrap-mount {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: calc(100% + 30px);\n}\n\n.wrap {\n  width: 283px;\n  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.18));\n  position: absolute;\n  z-index: 16;\n\n  & .popover-triangle {\n    content: '';\n    width: 2rem;\n    height: 2rem;\n    background: var(--white);\n    position: absolute;\n    top: calc(50% - 1rem);\n    left: 0;\n    transform: rotate(45deg) translateX(-20%);\n  }\n\n  & .popover {\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    background: var(--white);\n    padding: 20px;\n    border-radius: 0.8rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .popover-title {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 18px;\n    }\n\n    .popover-description {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 120%;\n\n      .text-primary {\n        color: var(--primary);\n      }\n    }\n\n    button {\n      width: 160px;\n      margin-top: 10px;\n    }\n  }\n}\n\n.wrap-btn {\n  top: -200%;\n  left: calc(100% - 25px);\n}\n\n.wrap-variant-btn {\n  top: -230%;\n  left: calc(100% - 25px);\n}\n\n.wrap-stroke {\n  top: -230%;\n  left: calc(100% - 2px);\n}\n\n.wrap-checkbox {\n  top: -300%;\n}\n\n.wrap-input {\n  top: -62px;\n  left: 27px;\n}\n\n.wrap-input2 {\n  top: -65px;\n  left: 40px;\n}\n\n.icon-file-excel:before {\n  content: '\\e903';\n  color: #378b59;\n  cursor: pointer;\n  font-size: 2.4rem;\n\n  &:hover {\n    border-color: var(--primary-30);\n  }\n\n  &:active {\n    border-color: var(--primary);\n  }\n\n  &:disabled {\n    border: 0.1rem solid var(--grey-variable-hover);\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.wraper-button {\n  position: relative;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  font-weight: 400;\n  font-size: 14px;\n  // margin-left: -4px;\n}\n\n.icon-add-new {\n  font-size: 22px;\n\n  &:before {\n    content: '\\e901';\n    color: var(--primary);\n  }\n}\n","@font-face {\n  font-family: 'icomoon';\n  src: url('../assets/fonts/icomoon/icomoon.eot?szk3ld');\n  src:\n    url('../assets/fonts/icomoon/icomoon.eot?szk3ld#iefix') format('embedded-opentype'),\n    url('../assets/fonts/icomoon/icomoon.ttf?szk3ld') format('truetype'),\n    url('../assets/fonts/icomoon/icomoon.woff?szk3ld') format('woff'),\n    url('../assets/fonts/icomoon/icomoon.svg?szk3ld#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n// @font-face {\n//   font-family: 'icomoon';\n//   src:  url('../assets/fonts/icomoon/icomoon.eot?b8qs3g');\n//   src:  url('../assets/fonts/icomoon/icomoon.eot?b8qs3g#iefix') format('embedded-opentype'),\n//     url('../assets/fonts/icomoon/icomoon.ttf?b8qs3g') format('truetype'),\n//     url('../assets/fonts/icomoon/icomoon.woff?b8qs3g') format('woff'),\n//     url('../assets/fonts/icomoon/icomoon.svg?b8qs3g#icomoon') format('svg');\n//   font-weight: normal;\n//   font-style: normal;\n//   font-display: block;\n// }\n\n[class^='icon-'],\n[class*=' icon-'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-logout:before {\n  content: '\\e923';\n  color: #4c4c4c;\n}\n.icon-lock:before {\n  content: '\\e924';\n  color: #4c4c4c;\n}\n.icon-tariff:before {\n  content: '\\e925';\n  color: #4c4c4c;\n}\n.icon-telegram:before {\n  content: '\\e922';\n  color: var(--primary);\n}\n.icon-file-email:before {\n  content: '\\e91f';\n  color: #4c4c4c;\n}\n.icon-file-xml:before {\n  content: '\\e920';\n  color: #1c4b76;\n}\n.icon-help:before {\n  content: '\\e921';\n  color: #4c4c4c;\n}\n.icon-upload:before {\n  content: '\\e91d';\n  // color: #4c4c4c;\n  color: var(--icon-primary-color);\n}\n.icon-complete:before {\n  content: '\\e91e';\n  color: #4c4c4c;\n}\n.icon-checkbox-selected:before {\n  content: '\\e919';\n  color: var(--primary);\n}\n.icon-checkbox:before {\n  content: '\\e91a';\n  color: #4c4c4c;\n}\n.icon-radio-selected:before {\n  content: '\\e91b';\n  color: var(--primary);\n}\n.icon-radio:before {\n  content: '\\e91c';\n  color: #e1e1e1;\n}\n.icon-add-new-outline:before {\n  content: '\\e902';\n  /* color: #4c4c4c; */\n}\n.icon-file-excel:before {\n  content: '\\e903';\n  color: #378b59;\n}\n.icon-account:before {\n  content: '\\e900';\n  color: #4c4c4c;\n}\n.icon-add-new:before {\n  content: '\\e901';\n  // color: #4c4c4c;\n}\n.icon-arrow:before {\n  content: '\\e904';\n}\n.icon-calendar:before {\n  content: '\\e905';\n  color: #4c4c4c;\n}\n.icon-cancel:before {\n  content: '\\e906';\n  /* color: #4c4c4c; */\n}\n.icon-charts:before {\n  content: '\\e907';\n  /* color: #4c4c4c; */\n}\n.icon-comment:before {\n  content: '\\e908';\n  /* color: #4c4c4c; */\n}\n.icon-copy:before {\n  content: '\\e909';\n  /* color: #4c4c4c; */\n}\n.icon-copyright:before {\n  content: '\\e90a';\n  color: #92929d;\n}\n.icon-delete:before {\n  content: '\\e90b';\n  /* color: #4c4c4c; */\n}\n.icon-download:before {\n  content: '\\e90c';\n  color: #4c4c4c;\n}\n.icon-edit:before {\n  content: '\\e90d';\n  /* color: #4c4c4c; */\n}\n.icon-export:before {\n  content: '\\e90e';\n  color: #4c4c4c;\n}\n.icon-eye:before {\n  content: '\\e90f';\n  color: #9a9ab0;\n}\n.icon-eye-hide:before {\n  content: '\\e910';\n  color: #9a9ab0;\n}\n.icon-file-image:before {\n  content: '\\e911';\n  color: #d9790c;\n}\n.icon-file-pdf:before {\n  content: '\\e912';\n  color: #ba3a3a;\n}\n.icon-file-text:before {\n  content: '\\e913';\n  color: #6badea;\n}\n.icon-folder:before {\n  content: '\\e914';\n  /* color: #4c4c4c; */\n}\n.icon-mark:before {\n  content: '\\e915';\n  color: #4c4c4c;\n}\n.icon-notes:before {\n  content: '\\e916';\n  color: #4c4c4c;\n}\n.icon-reports:before {\n  content: '\\e917';\n  /* color: #4c4c4c; */\n}\n.icon-search:before {\n  content: '\\e918';\n  /* color: #4c4c4c; */\n}\n.icon-bar-chart:before {\n  content: '\\e92c';\n}\n.icon-bar-chart-2:before {\n  content: '\\e92d';\n}\n.icon-icon-gears:before {\n  content: '\\e927';\n  color: #312782;\n}\n.icon-book .path1:before {\n  content: '\\e930';\n  color: rgb(255, 255, 255);\n}\n.icon-book .path2:before {\n  content: '\\e931';\n  margin-left: -1em;\n  color: rgb(76, 76, 76);\n}\n.icon-book .path3:before {\n  content: '\\e932';\n  margin-left: -1em;\n  color: rgb(76, 76, 76);\n}\n.icon-lamp:before {\n  content: '\\e933';\n  color: #5541d7;\n}\n.icon-feature-locked .path1:before {\n  content: '\\e92a';\n  color: rgb(49, 198, 126);\n}\n.icon-feature-locked .path2:before {\n  content: '\\e92b';\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-feature-img-locked .path1:before {\n  content: '\\e92e';\n  color: rgb(49, 198, 126);\n  opacity: 0.4;\n}\n.icon-feature-img-locked .path2:before {\n  content: '\\e92f';\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.icon-icon-arrow-down:before {\n  content: '\\e928';\n  /* color: #4c4c4c; */\n}\n.icon-icon-arrow-up:before {\n  content: '\\e929';\n  /* color: #4c4c4c; */\n}\n.icon-ic-alert:before {\n  content: '\\e926';\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
